// Premium Deposit Entry endpoints
export const PremiumDepositEndpoints = (builder) => ({
  getPremiumDepositEntry: builder.query({
    query: (args = {}) => {
      const {
        pageNumber = 1,
        pageSize = 10,
        searchTerm,
        searchValue,
        sortField,
        sortOrder,
        ...rest
      } = args;

      const params = { pageNumber, pageSize };
      if (searchTerm !== null && searchTerm !== undefined) params.searchTerm = searchTerm;
      if (searchValue !== null && searchValue !== undefined) params.searchValue = searchValue;
      if (sortField !== null && sortField !== undefined) params.sortField = sortField;
      if (sortOrder !== null && sortOrder !== undefined) params.sortOrder = sortOrder;

      // forward other primitive params if present
      Object.keys(rest).forEach((k) => {
        const v = rest[k];
        if (v !== null && v !== undefined && (typeof v !== 'object' || Array.isArray(v))) {
          params[k] = v;
        }
      });

      return {
        url: '/life-Insurance/get-premium-deposit-entry',
        method: 'GET',
        params,
      };
    },
    providesTags: ['PremiumDepositEntry'],
  }),

  getPremiumDepositEntryById: builder.query({
    query: (id) => ({
      url: `/life-Insurance/get-premium-deposit-entry/${id}`,
      method: 'GET',
    }),
    providesTags: (result, error, id) => [{ type: 'PremiumDepositEntry', id }],
  }),

  savePremiumDepositEntry: builder.mutation({
    query: (data) => ({
      url: '/life-Insurance/save-premium-deposit-entry',
      method: 'POST',
      body: data,
    }),
    invalidatesTags: ['PremiumDepositEntry'],
  }),

  updatePremiumDepositEntry: builder.mutation({
    query: ({ data }) => ({
      url: `/life-Insurance/save-premium-deposit-entry`,
      method: 'POST',
      body: data,
    }),
    invalidatesTags: (result, error, { id }) => [
      { type: 'PremiumDepositEntry', id },
      'PremiumDepositEntry',
    ],
  }),

  deletePremiumDepositEntry: builder.mutation({
    query: (id) => ({
      url: `/life-Insurance/delete-premium-deposit-entry/${id}`,
      method: 'DELETE',
    }),
    invalidatesTags: ['PremiumDepositEntry'],
  }),

  bulkDeletePremiumDepositEntry: builder.mutation({
    query: (body) => ({
      url: '/life-Insurance/bulk-delete-premium-deposit-entry',
      method: 'DELETE',
      body,
    }),
    invalidatesTags: ['PremiumDepositEntry'],
  }),
});
